import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export default function PrivateRoute({ children }) {
  const token = localStorage.getItem('access_token');
  const location = useLocation();
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
}
